/* eslint-disable */
import Component from 'gia/Component'

export default class ScrollingLinks extends Component {
  constructor(element) {
    super(element)
  }

  scroll() {
    const mainElement = $(this.element)
    const scroller = mainElement.find('.c-supplier-banner__page-links')
    const related = mainElement.find('.related-suppliers')

    function myHeight() {
      const height = mainElement.innerHeight() - related.innerHeight()
      scroller.height(height - 60)
    }

    $(window).load(function() {
      myHeight()
    })

    $(window).resize(function() {
      myHeight()
    })

    //smooth scroll
    mainElement
      .find('a[href^="#"]')
      .not('.m-add-to-list a')
      .not('.accordion-single__header a')
      .each(function() {
        $(this).click(function(e) {
          e.preventDefault()
          const myquery = $(this)
            .attr('href')
            .substr(1)
          const myobject = `[id="${myquery}"]`
          if (myobject) {
            document.querySelector(myobject).scrollIntoView({
              behavior: 'smooth',
            })
          }
        })
      })
  }

  mount() {
    this.scroll()
  }
}



// WEBPACK FOOTER //
// ./scripts/components/ScrollingLinks.js